import React, { Component } from "react";
import { Layout, Menu, Spin, Tabs } from "antd";
import {
  CalculatorOutlined,
  CloseSquareOutlined,
  ControlOutlined,
  DashboardOutlined, DatabaseOutlined,
  DeliveredProcedureOutlined,
  EuroOutlined,
  EyeOutlined,
  FileSearchOutlined,
  FormOutlined,
  KeyOutlined,
  LoginOutlined,
  ProfileOutlined,
  SendOutlined,
  SettingOutlined,
  ShopOutlined,
  SnippetsOutlined,
  SolutionOutlined,
  SwapOutlined,
  TeamOutlined, ThunderboltOutlined,
  ToolOutlined,
  UserOutlined,
} from "@ant-design/icons";

import { connect } from "react-redux";

import { Menu as sidebarMenu, SIDEBAR } from "../../utils/constants";

const { Sider } = Layout;

class Sidebar extends Component {
  state = {
    panes: [],
    collapsed: false,
    cacherTitre: false,
    checkedActive: false,
  };

  componentDidMount() {
    this.init(this.props);
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (this.props !== props) this.init(props);
  }

  init = (props) => {
    this.setState({ panes: props.panes });
  };

  getItem = (label, key, icon, children) => {
    return {
      key,
      icon,
      children,
      label,
    };
  };

  onClickMenu = (e) => {
    const item = sidebarMenu.find((item) => item.key === e.key);
    if (item) this.handleClickMenu(item.activeKey, item.label);
  };

  handleClickMenu = (key, title) => {
    let pane = null;
    if (!this.isKeyExists(this.state.panes, key)) pane = { key, title, content: "" };
    this.props.addPanes(pane, key);
  };

  isKeyExists = (panes, key) => {
    let result = panes.some((pane) => {
      return pane.key === key;
    });
    return result;
  };

  onCollapse = (collapsed) => this.setState({ collapsed });

  render() {
    const { collapsed } = this.state;
    const { loadingApplication, utilisateur, parametre } = this.props;

    const itemsMenu1 = [
      this.getItem("PROPRIÉTAIRES", "sub1", <KeyOutlined style={{ fontSize: 16 }} />, [
        this.getItem("Fiche", "1"),
        this.getItem("Relevés de gestion", "2"),
        this.getItem("Impression liste", "3"),
        this.getItem("Acompte", "sub1-4"),
      ]),
      // Affichage conditionnel de LOCATIONS
      ...(utilisateur && utilisateur?.societe_id === 45 ? [
        this.getItem("LOCATIONS", "sub6", <ThunderboltOutlined style={{ fontSize: 16 }} />, [
          this.getItem("Ajouter", "sub6-1"),
          this.getItem("En attente de lot", "sub6-2"),
        ])
      ] : []),

      this.getItem("LOTS", "sub2", <ShopOutlined style={{ fontSize: 16 }} />, [
        this.getItem("Fiche", "4"),
        this.getItem("Impression liste", "5"),
      ]),
      this.getItem("LOCATAIRES", "sub3", <UserOutlined style={{ fontSize: 16 }} />, [
        this.getItem("Fiche", "6"),
        this.getItem("Impression liste", "7"),
      ]),
      this.getItem("FICHIERS DIVERS", "sub4", <SnippetsOutlined style={{ fontSize: 16 }} />, [
        this.getItem("Immeubles", "8"),
        this.getItem("Agents", "50"),
      ]),
      this.getItem(
        "TRAITEMENTS",
        "sub5",
        <DeliveredProcedureOutlined style={{ fontSize: 16 }} />,
        []
      ),
    ];

    const itemsMenu2 = [
      this.getItem("GESTION COMMERCIALE", "sub1", <SolutionOutlined style={{ fontSize: 16 }} />, [
        this.getItem("Contrats / Disponibilités", "9"),
        this.getItem("Propositions", "10"),
        this.getItem("Options", "11"),
        this.getItem("Contrats", "12"),
        this.getItem("Quittancement", "52"),
        this.getItem("Liste des quittances", "57"),
        this.getItem("Requêtes archivées", "49"),
        this.getItem("Réservations propriétaire", "13"),
        this.getItem("Entrées / Sorties", "14"),
        this.getItem("Suivi des séjours", "58"),
        this.getItem("Statut des documents", "15"),
      ]),
      this.getItem("TABLEAU DE BORD", "sub2", <DashboardOutlined style={{ fontSize: 16 }} />, [
        this.getItem("Planning global", "16"),
        this.getItem("Liste des ménages", "56"),
        this.getItem("Historique parcours client", "17"),
        this.getItem("Liste des Timers", "18"),
        this.getItem("Liste des demandes", "55"),
      ]),
      this.getItem("TRAVELS MANAGERS", "sub3", <SendOutlined style={{ fontSize: 16 }} />, []),
      this.getItem("TARIFICATION", "sub4", <EuroOutlined style={{ fontSize: 16 }} />, [
        this.getItem("Références tarifaires", "19"),
        this.getItem("Grille des périodes", "20"),
        this.getItem("Règles internet", "21"),
      ]),
    ];

    const itemsMenu3 = [
      this.getItem("CONSULTATION", "sub1", <EyeOutlined style={{ fontSize: 16 }} />, [
        this.getItem("Interrogation de compte", "22"),
        this.getItem("Détail des encaissements", "59"),
        this.getItem("Récapitulatif C.A. par lots", "61"),
        this.getItem("Récapitulatif pour Revenus Fonciers", "62"),
        this.getItem("Récapitulatif des remises", "63"),
        this.getItem("Pointe", "23"),
      ]),
      this.getItem("SAISIES COMPTABLES", "sub2", <FormOutlined style={{ fontSize: 16 }} />, [
        this.getItem("Encaissement locataires", "24"),
        this.getItem("Validation de bordereau", "25"),
        this.getItem("Prestations Supplémentaires", "26"),
        this.getItem("Saisie Opérations Diverses", "27"),
        this.getItem("Annulation encaissement clients", "28"),
        this.getItem("Versement honoraires", "60"),
        this.getItem("Journaux", "29"),
        this.getItem("Plan comptable", "30"),
      ]),
      this.getItem("EDITIONS", "sub3", <FileSearchOutlined style={{ fontSize: 16 }} />, [
        this.getItem("Balance", "31"),
        this.getItem("Grand livre", "32"),
      ]),
      this.getItem("GESTION FOURNISSEUR", "sub4", <UserOutlined style={{ fontSize: 16 }} />, []),
      this.getItem("OUTILS", "sub5", <ToolOutlined style={{ fontSize: 16 }} />, [
        this.getItem("Recherche / Modification écritures", "33"),
        this.getItem("Lettrage de comptes", "54"),
        this.getItem("Écarts compta / encaiss.", "34"),
        this.getItem("Écarts compta / redd.", "51"),
      ]),
      this.getItem("RAPPRO. BANCAIRE", "sub6", <SwapOutlined style={{ fontSize: 16 }} />, [
        this.getItem("Rapprochement", "35"),
      ]),
      this.getItem(
        "CLOTURE EXERCICE",
        "sub7",
        <CloseSquareOutlined style={{ fontSize: 16 }} />,
        []
      ),
    ];

    const itemsMenu4 = [
      this.getItem("ACCES", "sub1", <LoginOutlined style={{ fontSize: 16 }} />, [
        this.getItem("Gestion dossier client", "36"),
        this.getItem("Mot de passe", "37"),
      ]),
      this.getItem("UTLISATEURS", "sub2", <TeamOutlined style={{ fontSize: 16 }} />, [
        this.getItem("Gestion utilisateur", "38"),
        this.getItem("Gestion des droits", "39"),
      ]),
      this.getItem("PARAMETRAGES", "sub3", <ControlOutlined style={{ fontSize: 16 }} />, [
        this.getItem("Société", "40"),
        this.getItem("Imputations", "42"),
        this.getItem("Types de paiements", "53"),
        this.getItem("Templates", "43"),
        this.getItem("Champs personnalisés", "44"),
        this.getItem("Étapes", "45"),
        this.getItem("Groupes", "46"),
        this.getItem("Rubriques", "47"),
      ]),
      //this.getItem("GESTION DE LA GED", "sub4", <FileWordOutlined style={{ fontSize: 16 }} />, []),
      this.getItem("OPÉRATEUR NUMÉRIQUE", "sub5", <DatabaseOutlined style={{ fontSize: 16 }} />, [
        this.getItem("Gestion des opérateurs", "450"),
        this.getItem("Import de données", "451"),
      ]),
    ];

    return (
      <Sider
        className="app-sidebar"
        collapsible
        width={SIDEBAR.WIDTH}
        collapsed={collapsed}
        onCollapse={this.onCollapse}
      >
        <Spin size="large" spinning={loadingApplication} tip="Chargement app...">
          {/* null (et non undefined) : Spin reste en mode imbriqué, sinon `tip` est ignoré */}
          {parametre ? (
            <Tabs
              className="tab-or"
              defaultActiveKey={1}
              items={[
                {
                  label: (
                    <UserOutlined style={{ fontSize: 18, color: "#F4C181", marginRight: 0 }} />
                  ),
                  key: 1,
                  children: (
                    <Menu
                      className="menu-or"
                      mode="inline"
                      theme="dark"
                      onClick={(e) => this.onClickMenu(e)}
                      items={itemsMenu1}
                    />
                  ),
                },
                {
                  label: (
                    <ProfileOutlined style={{ fontSize: 16, color: "#F4C181", marginRight: 0 }} />
                  ),
                  key: 2,
                  children: (
                    <Menu
                      className="menu-or"
                      mode="inline"
                      theme="dark"
                      onClick={(e) => this.onClickMenu(e)}
                      items={itemsMenu2}
                    />
                  ),
                },
                {
                  label: (
                    <CalculatorOutlined
                      style={{ fontSize: 16, color: "#F4C181", marginRight: 0 }}
                    />
                  ),
                  key: 3,
                  children: (
                    <Menu
                      className="menu-or"
                      mode="inline"
                      theme="dark"
                      onClick={(e) => this.onClickMenu(e)}
                      items={itemsMenu3}
                    />
                  ),
                },
                {
                  label: (
                    <SettingOutlined style={{ fontSize: 16, color: "#F4C181", marginRight: 0 }} />
                  ),
                  key: 4,
                  children: (
                    <Menu
                      className="menu-or"
                      mode="inline"
                      theme="dark"
                      onClick={(e) => this.onClickMenu(e)}
                      items={itemsMenu4}
                    />
                  ),
                },
              ]}
              centered
            />
          ) : null}
        </Spin>
      </Sider>
    );
  }
}

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    parametre: state.parametre.data,
  };
};

export default connect(mapStateToProps)(Sidebar);
